{
  "actions": {
    "switchLanguage": "Switch to Hebrew",
    "switchTheme": "Change color theme"
  },
  "auth": {
    "addPasskey": "Add another passkey",
    "backToSignIn": "Back to sign in",
    "bootstrapEyebrow": "First-time setup",
    "bootstrapHeading": "Set up the first admin account",
    "bootstrapSecret": "Setup secret",
    "createAccount": "Create an account",
    "createAccountHeading": "Join and start yapping.",
    "createAccountText": "Anyone can join this instance. Your passkey is your sign-in; no password needed.",
    "createPasskey": "Create a passkey and continue",
    "displayName": "Your name",
    "error": "We couldn't complete that step. Check the details and try again.",
    "errorConflict": "This step was already completed. Sign in instead.",
    "errorRateLimited": "Too many attempts. Wait a minute and try again.",
    "invitationEyebrow": "You've been invited",
    "invitationHeading": "Set up your YAAPS account",
    "loading": "Checking whether you're signed in...",
    "orRecovery": "Or sign in with a recovery code",
    "passkeyAdded": "Passkey added.",
    "recoveryCode": "Recovery code",
    "recoveryCodesHeading": "Save your recovery codes",
    "recoveryCodesWarning": "Each code can be used once. You won't be able to view them again.",
    "regenerateRecoveryCodes": "Generate new recovery codes",
    "regenerateRecoveryCodesConfirm": "Replace the codes",
    "regenerateRecoveryCodesWarning": "Your unused recovery codes will stop working the moment new ones are created.",
    "registerEyebrow": "Create an account",
    "registerHeading": "Join and start yapping.",
    "roleAdmin": "Administrator account",
    "roleUser": "User account",
    "savedRecoveryCodes": "I saved these codes",
    "signInEyebrow": "Welcome back",
    "signInHeading": "Sign in to YAAPS",
    "signInWithPasskey": "Sign in with a passkey",
    "signOut": "Sign out",
    "signedInEyebrow": "Signed-in account",
    "useRecoveryCode": "Sign in with recovery code",
    "working": "Please wait..."
  },
  "connect": {
    "approve": "Approve connection",
    "approveWarning": "Only approve if you started this connection yourself moments ago on your own device. The name shown is supplied by the requester and is not verified.",
    "approvedHeading": "Agent connected",
    "approvedText": "This one-time request was approved. Return to the agent to continue.",
    "askHeading": "Ask your AI to connect",
    "askPrompt": "Connect to YAAPS",
    "askText": "Open your AI and send this short request. It will give you a one-time code or open this page for approval.",
    "automaticTargets": "The installer detects Codex and Claude and installs the skill for every one it finds. If neither is detected, it installs both standard locations.",
    "claudeDetail": "Install the same portable skill for Claude.",
    "claudeName": "Claude",
    "clientLabel": "Requesting agent",
    "codeHelp": "Enter the one-time code shown by your agent.",
    "codeLabel": "Connection code",
    "codePlaceholder": "ABCD-EFGH",
    "codexDetail": "Install the YAAPS skill for Codex.",
    "codexName": "Codex",
    "commandIntro": "Copy this command and run it in your terminal:",
    "continueToApproval": "Continue to approval",
    "copied": "Copied",
    "copyCommand": "Copy command",
    "copyFailed": "Copying was blocked. Select the text and copy it manually.",
    "copyPrompt": "Copy request",
    "decided": "This connection request was already approved or denied. Start a new connection from your agent.",
    "deniedHeading": "Connection denied",
    "deniedText": "This one-time request was denied. The agent did not receive access.",
    "deny": "Deny connection",
    "downloadSkill": "Download the YAAPS skill ZIP",
    "expired": "This connection request has expired. Start a new connection from your agent.",
    "expires": "Expires",
    "genericDestination": "your AI client's Skills folder",
    "genericDetail": "Use YAAPS with another AI that supports Agent Skills.",
    "genericName": "Other Agent Skills AI",
    "heading": "Add YAAPS to your AI in three steps",
    "installHeading": "How do you want to install it?",
    "intro": "Install the portable skill, ask your AI to connect, and approve it here. No npm, executable app, or CLI installation is needed, and there is no API key for you to create or paste.",
    "invalid": "We could not find an active request for that code. Check it and try again.",
    "lookup": "Review request",
    "manualContinue": "I've installed the skill, continue",
    "manualCopy": "Copy the extracted yaaps folder to",
    "manualExtract": "Extract the downloaded ZIP file.",
    "methodHeading": "Choose an installation method",
    "methodNames": {
      "macos": "macOS",
      "manual": "Manual",
      "windows": "Windows"
    },
    "pendingHeading": "Approve the connection",
    "pendingText": "Approve only if you started this request in the AI shown below. Approval lets it publish and manage your YAAPS reports.",
    "platformHeading": "Where should the skill be copied?",
    "requestError": "We could not complete that request. Check the code and try again.",
    "reviewScript": "Open and review the installation script",
    "scriptSafety": "The script installs only the YAAPS skill files. You can open and review it before running the command.",
    "securityHeading": "What access the agent receives",
    "securityText": "After you approve, the agent receives an active API key with full control of your account's YAAPS reports: creating reports, viewing metadata and versions, changing titles, enabling, disabling, and permanently deleting them. Access remains active until you revoke the key in Settings. The key cannot sign in to the dashboard, change passkeys, or access your browser session.",
    "skillName": "YAAPS Agent Skill",
    "stepActive": "Current step",
    "stepApprove": "Approve",
    "stepAsk": "Ask your AI to connect",
    "stepCommandCopied": "Command copied",
    "stepComplete": "Complete",
    "stepInstall": "Install the skill",
    "stepInstalled": "Installed",
    "stepNext": "Next",
    "stepPromptCopied": "Request copied",
    "stepsLabel": "Connection steps"
  },
  "dashboard": {
    "eyebrow": "Install the skill. Ask your agent to publish.",
    "featureTexts": [
      "Install the YAAPS Skill once and use it with Codex, Claude, or another Agent Skills-compatible AI.",
      "When the report is ready, your agent returns a link you can open in a browser or send to anyone who needs it.",
      "Ask for a change and your agent can publish a new version. The link you already shared keeps working."
    ],
    "featureTitles": [
      "One portable skill",
      "The agent returns a link",
      "Update without a new link"
    ],
    "heading": "Your agent made a report. Now it can share it.",
    "intro": "Add the YAAPS Skill to Codex, Claude, or another compatible AI. Then ask it to publish a report in ordinary language and it gives you a link anyone can open.",
    "nextHeading": "Reports do not stay online forever",
    "nextText": "Reports expire after seven days by default. You can choose another expiry, stop sharing, or delete a report at any time.",
    "primaryAction": "Connect your agent",
    "securityEyebrow": "When you share with others",
    "securityHeading": "People who get the link see only the report.",
    "securityText": "The link does not give them access to your YAAPS account or other reports. Scripts, forms, embedded pages, and programmatic network requests stay blocked. Connected reports may load external HTTPS assets.",
    "secondaryAction": "View my reports",
    "statusHeading": "How publishing works",
    "statusItems": [
      "Install the YAAPS Skill",
      "Ask your AI to publish the report with YAAPS",
      "Approve the first connection and get a link to share"
    ],
    "terminalLabel": "What you say to your AI",
    "terminalPrompt": "Publish this report with $yaaps for 24 hours",
    "terminalPromptBeforeSkill": "Publish this report with",
    "terminalPromptAfterSkill": "for 24 hours",
    "terminalResponseLabel": "Your AI",
    "terminalSuccess": "The report was published to YAAPS for 24 hours.",
    "terminalOpenReport": "Open report",
    "terminalResult": "https://yaaps.net/d/8K2...Qp",
    "terminalExpiresAt": "Available until",
    "unavailable": "Already have an account? Sign in to see your reports and manage agent access."
  },
  "docs": {
    "authenticationHeading": "Authentication",
    "authenticationText": "Create an API key in Settings and store it in your application's secret environment. Send it with every authenticated request as a Bearer token. The full key is shown only once, so do not place it in source code, logs, or chat messages.",
    "endpointDescriptions": {
      "addVersion": "Publish a new version without changing the report's main link.",
      "categories": "List the categories your reports use, with the number of reports in each.",
      "create": "Publish a new report from one complete HTML document. Add a category to group it with related reports.",
      "delete": "Permanently delete a report and all of its versions.",
      "inspect": "Get the details of one report owned by your account.",
      "list": "List the reports owned by your account, optionally filtered by category.",
      "update": "Change the title or category, or start and stop sharing the report.",
      "versions": "List every version of a report."
    },
    "endpointsHeading": "Endpoints",
    "endpointsIntro": "Use these operations to publish reports, add immutable versions, control availability, and delete reports. Each API key can access only reports owned by its account.",
    "errorHeading": "Error responses",
    "errorText": "Every error includes a stable code that API clients can handle and a short explanation of what went wrong.",
    "eyebrow": "API reference",
    "heading": "Build with the YAAPS API",
    "intro": "Publish and manage isolated or connected HTML reports over HTTP. Use the live reference below to inspect the schema, try authenticated operations, or generate a client.",
    "limitsHeading": "Limits",
    "limitsItems": [
      "Maximum HTML file size: 10 MB",
      "Default lifetime: 7 days",
      "Allowed lifetime: 1 hour to 1 year",
      "Up to 100 results per page"
    ],
    "openApiAction": "Open the OpenAPI 3.1 spec",
    "openApiText": "View the complete API schema or use it to generate a client.",
    "quickStartHeading": "Publish a report",
    "quickStartIntro": "Set your YAAPS base URL and API key, then send one complete HTML document in the request body. Connected is the default and may load external HTTPS images, stylesheets, and fonts. Choose isolated explicitly to block external resource loading. The optional category groups the report with related ones.",
    "redocAction": "Read the API in ReDoc",
    "redocText": "Browse a clean, searchable reference generated from the live specification.",
    "responseHeading": "Response",
    "securityHeading": "How YAAPS protects report readers",
    "securityText": "Anyone with the link can open the report. Isolated reports block external resources. Connected reports may load HTTPS images, stylesheets, and fonts. Both modes block scripts, form submissions, frames, plugins, programmatic network requests, and same-origin access.",
    "tocLabel": "On this page",
    "swaggerAction": "Explore with Swagger UI",
    "swaggerText": "Inspect requests and try authenticated API operations interactively."
  },
  "management": {
    "accepted": "Accepted",
    "accountHeading": "Sign-in security",
    "active": "Active",
    "adminError": "We couldn't load or update the admin data. Try again.",
    "adminEyebrow": "Administration",
    "adminHeading": "Manage users and invitations",
    "adminIntro": "Invite people, choose their access level, and disable accounts when needed. You never need to sign in as another user.",
    "allReportsHeading": "Reports from all users",
    "cancel": "Cancel",
    "categoryChoose": "Choose a category",
    "categoryClear": "Remove category",
    "categoryEdit": "Change category",
    "categoryFilterAll": "All reports",
    "categoryFilterLabel": "Filter by category",
    "categoryFilterOption": "Show only {category} ({count})",
    "categoryLabel": "Category",
    "categoryNew": "New category…",
    "categoryNewLabel": "New category name",
    "categoryPlaceholder": "Weekly reports",
    "categorySave": "Save category",
    "categorySet": "Add category",
    "confirmDelete": "Yes, delete it",
    "confirmDisableUser": "Yes, disable this user",
    "confirmRevoke": "Yes, revoke this key",
    "copied": "Copied",
    "copyKey": "Copy key",
    "createInvitation": "Create invitation link",
    "createKey": "Create API key",
    "delete": "Delete",
    "disable": "Stop sharing",
    "disableUser": "Disable",
    "draftCount": "report",
    "draftsCount": "reports",
    "emptyCategoryHeading": "Nothing in this category",
    "emptyCategoryText": "No report is in {category} right now. Pick another category or show all reports.",
    "emptyReportsHeading": "No reports yet",
    "emptyReportsText": "When your agent publishes a report to YAAPS, it will show up here.",
    "enable": "Share again",
    "enableUser": "Enable",
    "enabled": "Public",
    "error": "We couldn't complete that request. Try again.",
    "expired": "Expired",
    "expires": "Expires:",
    "extend": "Extend expiry",
    "extendDay": "1 day",
    "extendMonth": "30 days",
    "extendWeek": "7 days",
    "extendYear": "1 year",
    "eyebrow": "Published by your agents",
    "heading": "My reports",
    "hideVersions": "Hide versions",
    "intro": "Open reports, review their versions, and decide which links should keep working.",
    "invitationReady": "Invitation link created",
    "invitationWarning": "Copy and share this link securely. The full link won't be shown again.",
    "inviteHeading": "Invite a user",
    "inviteRole": "Account type",
    "keyCount": "active API key",
    "keyLabel": "Key name",
    "keyPlaceholder": "My local agent",
    "keyReady": "API key created",
    "keyWarning": "Copy it now and add it to your agent's secrets. The full key won't be shown again.",
    "keysCount": "active API keys",
    "keysEyebrow": "Agent access",
    "keysHeading": "API keys for agents",
    "lastUsed": "Last used:",
    "loading": "Loading...",
    "neverUsed": "Never used",
    "openReport": "Open report",
    "owner": "Owner:",
    "pending": "Pending",
    "remaining": "{duration} left",
    "rename": "Rename",
    "renameSave": "Save name",
    "reportDisabled": "Not shared",
    "resourcePolicyConnected": "External HTTPS assets",
    "resourcePolicyIsolated": "Isolated",
    "reportsEyebrow": "Published by your agents",
    "reportsHeading": "Reports",
    "revoke": "Revoke",
    "revokeInvitation": "Revoke invitation",
    "revoked": "Revoked",
    "roleAdmin": "Administrator",
    "roleUser": "User",
    "savedInvitation": "Done",
    "savedKey": "Done",
    "settingsEyebrow": "Account settings",
    "settingsHeading": "Agent access and account sign-in",
    "settingsIntro": "Create API keys for your agents and add passkeys for signing in to your account.",
    "showVersions": "View versions",
    "showingLimited": "Showing the {shown} most recent of {total}.",
    "summary": "Account summary",
    "untitled": "Untitled report",
    "userDisabled": "Disabled",
    "usersHeading": "Users",
    "version": "Version",
    "versionsHeading": "Saved versions",
    "views": "Views: {count}"
  },
  "navigation": {
    "administration": "Admin",
    "ariaLabel": "Main navigation",
    "connect": "Connect agent",
    "dashboard": "My reports",
    "docs": "API docs",
    "settings": "Settings"
  },
  "product": {
    "footer": "Your agent publishes. You share.",
    "name": "YAAPS",
    "tagline": "Share reports from any AI agent"
  },
  "status": {
    "label": "Works with any agent"
  },
  "theme": {
    "dark": "Dark",
    "light": "Light"
  },
  "titles": {
    "admin": "Administration | YAAPS",
    "approve": "Approve agent connection | YAAPS",
    "connect": "Connect your agent | YAAPS",
    "dashboard": "My reports | YAAPS",
    "docs": "API documentation | YAAPS",
    "landing": "YAAPS | Share reports from any AI agent",
    "login": "Sign in | YAAPS",
    "settings": "Settings | YAAPS"
  }
}
